import { Packages, PackagesInitialState, ReduxAction } from "../models";
import { ModalsType, PackagesType } from "../types";
import { UserSessionTypes } from "../types/user.session.types";

export const PackagesState = (state: Packages = PackagesInitialState, action?: ReduxAction): Packages => {
    if (!action) return state;

    switch (action.type) {
        case PackagesType.SHOW_PACKAGES_LOADING:
        case PackagesType.REQUEST_CREATE_ORDER:
        case PackagesType.REQUEST_ORDER_INFO:
        case PackagesType.ADD_DISCOUNT_CODE:
        case PackagesType.REMOVE_DISCOUNT_CODE:
        case PackagesType.PAY_ORDER:
        case PackagesType.SEND_VAS_SMS:
        case PackagesType.VERIFY_VAS_SMS:
        case PackagesType.REQUEST_PACKAGES:
        case PackagesType.REQUEST_PACKAGE_DETAIL:
            return { ...state, loading: true };
        case PackagesType.HIDE_PACKAGES_LOADING:
            return { ...state, loading: false };
        case PackagesType.SET_ORDER_INFO:
            return { ...state, loading: false, order: { ...action.payload, banks: action.payload.banks || state.order?.banks } };
        case PackagesType.VAS_SMS_SENT:
            return { ...state, loading: false, smsSent: true };
        case PackagesType.CLEAR_PACKAGE_STATE:
        case ModalsType.SHOW_PACKAGES_MODAL:
        case UserSessionTypes.LOGOUT_USER:
            return { ...PackagesInitialState };
        case PackagesType.CLEAR_PACKAGE__DETAIL_STATE:
            return { ...PackagesInitialState, packageListLoaded: state.packageListLoaded, packages: state.packages };
        case PackagesType.SEND_GIFT_CODE:
            return { ...state, sendingGiftCode: true, giftCodeApplied: false };
        case PackagesType.GIFT_CODE_SENT:
            return { ...state, sendingGiftCode: false, giftCodeApplied: action.payload };
        case PackagesType.SET_PACKAGES:
            return { ...state, loading: false, packages: action.payload, packageListLoaded: true };
        case PackagesType.SET_PACKAGE_DETAIL:
            return { ...state, loading: false, currentPackage: action.payload };
    }

    return state;
};
